'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react-reconciler-reflection.production.min.js');
} else {
  module.exports = require('./cjs/react-reconciler-reflection.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/react-reconciler/reflection.js
// module id = 4402
// module chunks = 168707334958949